import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-light-surface dark:bg-charcoal border-t border-light-text/10 dark:border-silver/10">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Logo/Brand */}
          <div className="flex items-center">
            <span className="font-display text-xl italic tracking-tighter text-light-text dark:text-pure-white">
              Calendiary
            </span>
          </div>

          {/* Navigation Links */}
          <nav className="flex items-center gap-6" aria-label="Footer navigation">
            <Link
              to="/terms-of-service"
              className="font-body text-sm text-light-text-secondary dark:text-silver/80 hover:text-light-text dark:hover:text-pure-white transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy-policy"
              className="font-body text-sm text-light-text-secondary dark:text-silver/80 hover:text-light-text dark:hover:text-pure-white transition-colors"
            >
              Privacy Policy
            </Link>
          </nav>

          {/* Copyright */}
          <div className="font-body text-sm text-light-text-secondary dark:text-silver/60">
            &copy; {currentYear} Calendiary. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
